import translate from '@allesauto/i18n';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import testDriveBookingSchema from '../validation/testDriveBookingSchema';

export const useTranslationTestDriveBooking = () => {
  const intl = useIntl();

  const memoizedTestDriveBookingTranslations = useMemo(
    () => ({
      USER_MSG_LINK: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.USER_MSG_LINK'
      ),
      USER_MSG_LABEL: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.USER_MSG_LABEL'
      ),
      EMAIL_LABEL: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.EMAIL'),
      FIRST_NAME: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.FIRST_NAME'),
      LAST_NAME: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.LAST_NAME'),
      APPOINTMENT_SUBTITLE: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.APPOINTMENT_SUBTITLE'
      ),
      ALTERNATIVE_DATE_FIELDS: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.ALTERNATIVE_DATE_FIELDS'
      ),
      TIMEWINDOW_1: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.TIMEWINDOW_1'),
      DATE_PLACEHOLDER_TEXT_1: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.DATE_PLACEHOLDER_TEXT_1'
      ),
      TIMEWINDOW_2: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.TIMEWINDOW_2'),
      DATE_PLACEHOLDER_TEXT_2: translate(
        intl,
        'ui.FORMS.TEST_DRIVE_BOOKING.DATE_PLACEHOLDER_TEXT_2'
      ),
      REQUIRED_FIELD_NOTE: translate(
        intl,
        'ui.FORMS.COMMON.REQUIRED_FIELD_NOTE'
      ),
      BUTTON_TEXT: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.BUTTON_TEXT'),
      PHONE_NUMBER: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.PHONE_NUMBER'),
    }),
    [intl]
  );

  const memoizedTestDriveBookingFormSchema = useMemo(() => {
    const validationMsgs = {
      firstName: {
        format: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.ONLY_LETTERS_MSG'),
        required: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.REQUIRED_MSG', {
          field: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.FIRST_NAME'),
        }),
        minLength: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.MIN_LENGTH', {
          minNo: '2',
        }),
        maxLength: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.MAX_LENGTH', {
          maxNo: '100',
        }),
      },
      lastName: {
        format: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.ONLY_LETTERS_MSG'),
        required: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.REQUIRED_MSG', {
          field: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.LAST_NAME'),
        }),
        minLength: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.MIN_LENGTH', {
          minNo: '2',
        }),
        maxLength: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.MAX_LENGTH', {
          maxNo: '100',
        }),
      },
      email: {
        format: translate(
          intl,
          'ui.FORMS.TEST_DRIVE_BOOKING.EMAIL_INVALID_MSG'
        ),
        required: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.REQUIRED_MSG', {
          field: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.EMAIL'),
        }),
      },
      phone: {
        minLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MIN'),
        maxLength: translate(intl, 'ui.FORMS.VALIDATION_MESSAGES.STRING.MAX'),
      },
      requestTimeSlot: {
        required: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.REQUIRED_MSG', {
          field: translate(intl, 'ui.FORMS.TEST_DRIVE_BOOKING.DATE'),
        }),
      },
    };
    return testDriveBookingSchema(validationMsgs);
  }, [intl]);

  return {
    memoizedTestDriveBookingTranslations,
    memoizedTestDriveBookingFormSchema,
  };
};

export default useTranslationTestDriveBooking;
